import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OfbizForm } from '@urbannex/ofbiz-forms';
import { ConfigOptions } from '@urbannex/view-containers';

@Component({
  selector: 'pty-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  partyId:string;
  constructor(private route:ActivatedRoute){
    this.route.paramMap.subscribe((params) => {
      if(params.get("partyId")){
        this.partyId = params.get("partyId");
      }
    })
  }
 /* options:ConfigOptions = {
   name: '',
   title: '',
   findForm: new OfbizForm,
   addForm: new OfbizForm,
   summaryView:[
    {
      title:"Basic Info",
      order: 1,
      formName:"ViewPartyPerson",
      formLocation:"component://kwikstore/widget/PartyForms.xml",
      params:["partyId"],
      ofbizForm:new OfbizForm({
        formName:"ViewPartyPerson",
        formLocation:"component://kwikstore/widget/PartyForms.xml",

      }),
      fullWidth:false,
    }
   ],
   actions: [],
   settings: []
 } */
}
